import { computed } from "vue";

const urlTemp = computed(() => {
  let url = import.meta.env.VITE_APP_URL;
  if (window.location.hostname.split(".")[0] == "damcorp") {
    url = import.meta.env.VITE_DAMCORP_URL;
  } else if (window.location.hostname.split(".")[0] == "bawaslu") {
    url = import.meta.env.VITE_BAWASLU_URL;
  } else if (window.location.hostname.split(".")[0] == "pgd-omni") {
    url = import.meta.env.VITE_PEGADAIAN_URL;
  } else {
    url = import.meta.env.VITE_APP_URL;
  }
  return url;
});

export default urlTemp;
